// extracted by mini-css-extract-plugin
export default {"wrapper":"slideSelect_wrapper__nr-LH","option":"slideSelect_option__cyNTs"};